import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { SocialCoachSession } from "@/services/bedrock/dtos";

const SESSION_SERVICE = `${Constants.API_URL}/bedrock/me`;

export class SessionServices {
  @scCatchServiceException()
  static async getMe(skipAuthRedirect?: boolean): Promise<SocialCoachSession> {
    const { data } = await axios.get<SocialCoachSession>(SESSION_SERVICE, {
      ...({ skipAuthRedirect } as any),
    });
    return data;
  }
}
